import { useMutation } from '@apollo/client/react'
import { concatAST } from 'graphql'
import type {
  ReAssignDocumentMutation,
  ReAssignDocumentMutationVariables,
} from '~app/graph/generated/graphql'
import documentFragment from './documentFragment'
import reAssignDocument from './reassign-document.graphql'

const reAssignDocumentMutation = concatAST([documentFragment, reAssignDocument])

export const useReAssignDocument = () =>
  useMutation<ReAssignDocumentMutation, ReAssignDocumentMutationVariables>(
    reAssignDocumentMutation
  )
